import { getStore, setStore } from '@/util/store'
const common = {
  state: {
    currentLang: getStore({ name: 'currentLang' }) || 'ja',
  },
  actions: {
    ChangeLang({
      commit,
      state,
      dispatch
    }, data) {
      return new Promise(resolve => {
        commit('SET_CURRENTLANG', data)
        console.log('data', data)
        resolve()
      })
    },
  },

  mutations: {
    SET_CURRENTLANG: (state, data) => {
      state.currentLang = data
      setStore({ name: 'currentLang', content: data, type: 'session' })
    },
  },
}
export default common
